import { render, staticRenderFns } from "./PersonalizationListView.vue?vue&type=template&id=78933480&scoped=true"
import script from "./PersonalizationListView.vue?vue&type=script&lang=js"
export * from "./PersonalizationListView.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationListView.vue?vue&type=style&index=0&id=78933480&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78933480",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78933480')) {
      api.createRecord('78933480', component.options)
    } else {
      api.reload('78933480', component.options)
    }
    module.hot.accept("./PersonalizationListView.vue?vue&type=template&id=78933480&scoped=true", function () {
      api.rerender('78933480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/personalization/PersonalizationListView.vue"
export default component.exports